module.exports = __webpack_public_path__ + "static/img/14.8a6616cc.png";